import React from 'react';
import Checklist from '../../../assets/images/checklist.png';
import Checklist3 from '../../../assets/images/checklist3.png';
import Telefone from '../../../assets/images/telefone.svg';
import * as FcIcons from "react-icons/fc";


import './styles.css';
import { Accordion, ListGroup, ListGroupItem } from 'react-bootstrap';

const Rural = () => {
    // const location = useLocation();

    // useEffect(() => {
    //     window.scrollTo({
    //         top: 0,
    //         behavior: 'smooth'
    //     });
    // }, [location.pathname]);
    return (

        <div className="rural-content">
            <h5>Como funciona a nossa internet rural?</h5>
            <h5>Que tecnologia utilizamos?</h5><br />
            <span>
                Utilizamos a tecnologia de telefonia móvel 4G, oferecemos acesso à internet,
                conectividade rápida e estável de alta velocidade para áreas rurais.
                Nossos clientes podem desfrutar de navegação na web, streaming de vídeos e chamadas de
                vídeo sem interrupções.
                Com planos acessíveis e ampla cobertura, garantimos uma conexão confiável e
                rápida para que todos possam aproveitar os benefícios da era digital.
            </span>
            <br />
            <hr />
            <div className="container-fluid">

                <div className="row">

                    <div className="col-sm-12 col-md-5 py-5">
                        <h1>Checklist do atendimento:</h1>

                        <img src={Checklist} alt='foto' />
                    </div>
                    <div className="col-sm-12 col-md-7">

                        <div className='check-list'>
                            <h3> 🌾Internet Rural: Conectividade ilimitada!</h3>
                            <Accordion>
                                <Accordion.Item eventKey="0" className="accordion-list">
                                    <Accordion.Header>1. Apresentar a Internet Rural 4G da Gigabyte Telecom: </Accordion.Header>
                                    <Accordion.Body>
                                        Apresentamos a Internet Rural 4G LTE, uma solução desenvolvida especialmente para conectar
                                        as propriedades rurais ao mundo digital, atendendo às necessidades de conectividade nessas áreas
                                        de forma estável e confiável. Com velocidade de até 10 Megas para downloads e 5 Megas para uploads. E o melhor, livre de qualquer franquia de dados (navegação ilimitada).

                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1" className="accordion-list">
                                    <Accordion.Header>2. Informar as cidades atendidas pelo serviço: </Accordion.Header>
                                    <Accordion.Body>
                                        Nossos serviços de Internet Rural estão disponíveis em diversas cidades, incluindo Jaraguá, Ceres,
                                        Uruana, Uruaçu e Rubiataba. Se sua propriedade rural está localizada em um desses municípios você não pode ficar de fora.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2" className="accordion-list">
                                    <Accordion.Header>3. Informar sobre a promoção especial de adquirir o kit completo por R$ 500,00. </Accordion.Header>
                                    <Accordion.Body>
                                        Aproveite essa oportunidade e adquira agora mesmo o Plano Internet Rural da Gigabyte Telecom por apenas R$ 500,00 "no dinheiro".
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3" className="accordion-list">
                                    <Accordion.Header>4. Incentivar o cliente a aproveitar os benefícios do Plano Internet Rural: </Accordion.Header>
                                    <Accordion.Body>
                                        Com velocidade de até 10 Megas, você terá uma navegação rápida e eficiente, seja para acessar suas redes sociais,
                                        assistir a vídeos, realizar videochamadas ou até mesmo trabalhar remotamente.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4" className="accordion-list">
                                    <Accordion.Header>5. Para aproveitar o preço promocional oferecido, o cliente precisa concordar em ficar fidelizado por um período de um ano. </Accordion.Header>
                                    <Accordion.Body>
                                        Essa fidelização é estabelecida em um contrato, no qual são definidos os termos e condições.
                                        Caso o cliente decida encerrar o contrato antes do prazo estipulado, será aplicada uma multa gradual,
                                        que varia de acordo com o tempo que permaneceu como cliente. Essa medida visa
                                        garantir a sustentabilidade do serviço e incentivar a manutenção do contrato por parte do cliente.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="7" className="accordion-list">
                                    <Accordion.Header>6. <strong> Qual o valor da multa caso tenha quebra de fidelidade.</strong> </Accordion.Header>
                                    <Accordion.Body>
                                        <ListGroup>
                                            <div className='list-row'>
                                                <div className='list-colunm'>
                                                    <ListGroup.Item>
                                                        1º mês: R$ 700,00
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        2º mês: R$ 641,67
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        3º mês: R$ 583,34
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        4º mês: R$ 525,01
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        5º mês: R$ 466,68
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        6º mês: R$ 408,35
                                                    </ListGroup.Item>
                                                </div>
                                                <div className='list-colunm'>
                                                    <ListGroup.Item>
                                                        7º mês: R$ 350,02
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        8º mês: R$ 291,69
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        9º mês: R$ 233,36
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        10º mês: R$ 175,03
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        11º mês: R$ 116,70
                                                    </ListGroup.Item>
                                                    <ListGroup.Item>
                                                        12º mês: R$ 58,37
                                                    </ListGroup.Item>
                                                </div>
                                            </div>

                                        </ListGroup>

                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5" className="accordion-list">
                                    <Accordion.Header>7. <strong> Caso o cliente não queira aproveitar a promoção com fidelidade, qual é o valor da instalação? </strong></Accordion.Header>
                                    <Accordion.Body>
                                        ????
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="6" className="accordion-list">
                                    <Accordion.Header>8. <strong> Os aparelhos fornecidos pela Gigabyte Telecom são em comodato? </strong></Accordion.Header>
                                    <Accordion.Body>
                                        ????
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="8" className="accordion-list">
                                    <Accordion.Header>9. <strong> Mais alguma informação a ser adicionada nesse informativo?</strong> </Accordion.Header>
                                    <Accordion.Body>
                                        ????
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="9" className="accordion-list">
                                    <Accordion.Header>10. <strong> Qual o prazo médio para a instalação? </strong></Accordion.Header>
                                    <Accordion.Body>
                                        ????
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>

                    </div>
                </div>
                <br />
                <hr />
                <br />
                <div className="row">

                    <div className="col-sm-12 col-md-5" >
                        <img src={Telefone} alt='foto' />
                        <br /><br /><br /><br />
                    </div>
                    <div className="col-sm-12 col-md-7">

                        <h3><FcIcons.FcApproval /> Oportunidade imperdível!</h3>
                        <span>
                            Motivar o cliente a aproveitar a oportunidade ao adquirir o Plano de Internet Rural.
                            Com ele, poderá também adquirir um Plano de Telefone Fixo Rural via internet,
                            conectando de vez sua propriedade rural ao mundo moderno.
                            <br />
                            <br />
                            <br />
                        </span>
                        <h4>
                            📋 Checklist para oferecer o telefone fixo rural aos clientes após a contratação da nossa Internet Rural:
                        </h4>
                        <br />
                        <ListGroup>
                            <ListGroup.Item>
                                ☑️ Comunicação estável e confiável mesmo em áreas distantes das cidades.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ☑️ Tranquilidade de poder fazer e receber chamadas importantes.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ☑️ Eliminação das dificuldades de sinal enfrentadas com celulares.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ☑️ Conexão permanente com familiares, parceiros de negócios e serviços de emergência.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ☑️ Tarifas acessíveis para ligações locais e interurbanas.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ☑️ Praticidade de ter um número fixo para ser facilmente encontrado.
                            </ListGroup.Item>
                        </ListGroup>
                    </div>
                </div>
            </div>

            <hr />

            <div className="row">
                <div className="col-sm-12 col-md-5">
                    <h5>Exigências e documentação necessaria para a contratação desse plano.</h5>
                    <img src={Checklist3} alt="foto"></img>
                </div>
                <div className="col-sm-12 col-md-7">
                    <h3>Checklist para a contrar o plano:</h3>
                    <div>
                        <ListGroup>
                            <ListGroup.Item>
                                ✅ Informar que o cliente deve mandar a localização via Whatsapp para verificar se propriedade dele está localizado na área de cobertura.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ✅ Informar que o cliente titular do contrato deverá estar presente para assina-lo.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ✅ Agendamento de instalação: Informe ao cliente que um dos nossos atendentes entrará
                                em contato para agendar a visita do técnico responsável pela instalação do plano.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ✅ Confirmação prévia da presença: Destaque que o técnico responsável pela instalação
                                entrará em contato momentos antes da visita para confirmar se há alguém presente no local
                                e que este seja responsável pela assinatura do contrato, ou que chegará em tempo hábil para assina-lo.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ✅ Informe também que a instalação só será concluida após a assinatura do contrato de adesão.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ✅ Informar ao cliente que o pagamento pela instalação deve ser efetuado diretamente ao técnico
                                responsável, podendo ser realizado em dinheiro ou por meio de Pix para a Melo Telecomunicações.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ✅ Perguntar se o cliente tem alguma mais alguma dúvida sobre a contratação do plano.
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ✅ Criar Ordem de Serviço (OS) para o departamento/técnico responsável.
                            </ListGroup.Item>
                        </ListGroup>
                    </div>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className='title'>                    
                    <h1>Feedback</h1>
                </div>
                <div className="col-sm-12 col-md-6">

                    Olá, [Nome do Cliente], saudações!<br /><br />

                    Aqui é [Seu nome] da Gigabyte Telecom! Esperamos que você esteja aproveitando nossa conexão de internet [nome do plano] e que esteja atendendo às suas expectativas.
                    <br /><br />
                    Estamos entrando em contato para saber se você teria um tempinho para responder algumas perguntas rápidas sobre sua experiência até o momento. Queremos garantir que você esteja satisfeito com nossos serviços e que tudo esteja funcionando perfeitamente para você.
                    <br /><br />
                    As perguntas serão bem simples e não levarão muito do seu tempo. Sua opinião é muito importante para nós e nos ajuda a melhorar nossos serviços para atender ainda melhor às suas necessidades.
                    <br /><br />
                    Se estiver disponível para nos dar esse feedback, ficaremos muito agradecidos. Caso prefira, podemos agendar uma ligação para um horário que seja mais conveniente para você.
                    <br /><br />
                    De qualquer forma, estamos aqui para ajudar e garantir que você tenha a melhor experiência com a Gigabyte Telecom.
                    <br /><br />
                    Agradecemos pela sua atenção e aguardamos seu retorno.

                </div>
                <div className="col-sm-12 col-md-6">
                    <h3>Checklist pós venda:</h3>
                    <div>
                        <ListGroup>
                            <ListGroup.Item>
                                ❓ 1 - Em uma escala de 0 a 10, qual nota você daria para a pontualidade do técnico na chegada ao local de instalação?
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ❓ 2 - Como você avalia a cortesia e educação do técnico durante o atendimento, em uma escala de 0 a 10?
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ❓ 3 - Em relação à clareza das explicações dadas pelo técnico sobre o funcionamento dos equipamentos instalados, qual nota você atribuiria, em uma escala de 0 a 10?
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ❓ 4 - Como você avalia a agilidade e eficiência do técnico na realização da instalação, em uma escala de 0 a 10?
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ❓ 5 - Em uma escala de 0 a 10, qual nota você daria para a habilidade do técnico em resolver eventuais problemas ou dúvidas durante a instalação?
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ❓ 6 - Considerando o cuidado do técnico com o ambiente durante a instalação, qual nota você daria, em uma escala de 0 a 10?
                            </ListGroup.Item>
                            <ListGroup.Item>
                                ❓ 7 - Como você avalia a disponibilidade do técnico em responder suas perguntas e fornecer informações adicionais, em uma escala de 0 a 10?
                            </ListGroup.Item>
                            <ListGroupItem>
                                ❓ 8 - Em relação à limpeza e organização dos equipamentos deixada pelo técnico após a instalação, qual nota você atribuiria, em uma escala de 0 a 10?
                            </ListGroupItem>
                            <ListGroupItem>
                                ❓ 9 - Em geral, qual nota você daria para o atendimento do técnico de instalação, em uma escala de 0 a 10?
                            </ListGroupItem>
                        </ListGroup>
                        <br />
                        Lembrando que sua opinião é muito importante para nós, e suas respostas nos ajudarão a aprimorar nossos serviços e garantir a melhor experiência para todos
                        os nossos clientes. Agradecemos sua colaboração!
                    </div>
                </div>
            </div>
        </div>




    )
}
export default Rural;